'use client';
import React, { useState } from 'react';

export default function FinalCTA() {
  const [showMessage, setShowMessage] = useState(false);

  const handleBlockedClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowMessage(true);
  };

  return (
    <section className="py-20 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Your next meal is{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #f97316, #f5c518)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontStyle: 'italic',
            }}
          >
            18 minutes away.
          </span>
        </h2>
        <p className="text-gray-400 text-base mb-10">
          Download Mdeliva or order from your browser. No account needed for your first order.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={handleBlockedClick}
            className="flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-black text-base transition-all duration-200 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #38bdf8, #0ea5e9)' }}
          >
            <span>📱</span>
            <span>Download the app</span>
          </button>
        </div>

        {/* Blocked navigation message */}
        {showMessage && (
          <div className="mt-6 max-w-md mx-auto bg-[#1a0e00] border border-[#f97316]/40 rounded-2xl px-6 py-4 flex items-start gap-3 text-left">
            <span className="text-[#f97316] text-xl mt-0.5 flex-shrink-0">⚠️</span>
            <div>
              <p className="text-gray-300 text-sm leading-relaxed">
                Sorry but try again later. For this app is still being polished — making it ready for public use and for more information, reach out to us through the{' '}
                <a href="/contact" className="text-[#f97316] underline hover:text-[#f5c518] transition-colors">
                  contact page
                </a>
                .
              </p>
              <button
                onClick={() => setShowMessage(false)}
                className="mt-2 text-xs text-gray-500 hover:text-gray-300 transition-colors"
              >
                Dismiss
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
